import { useState } from "react";
import { useNavigate } from "react-router";
import _ from "lodash";

import { useRootStore } from "store";
import MKLoader from "components/loader/MKLoader";
import { Attachment } from "models/dashboard/dashboard";
import { DocumentUploadFile } from "models/DocumentUploadFile";
import CreateThread from "views/inbox/containers/createThread/CreateThread";
import useSetErrorOnUpload from "hooks/use-set-error-on-upload";
import FileUploadErrorModal from "components/shared/fileUploadErrorModal/FileUploadErrorModal";

type File = {
  id: string;
  name: string;
  type: string;
};

export default function MessageEditor() {
  const navigate = useNavigate();

  const { global, user, archive, inbox } = useRootStore((store) => store);

  const { sendFileToArchive } = archive;

  const { fetchThread, loadInbox, sendMessage } = inbox;

  const [isSending, setIsSending] = useState(false);

  const { failed, setFailed, failMessage, setFailedWrapper } =
    useSetErrorOnUpload();

  const handleOnSend = async (
    title: string,
    body: string,
    recipients: string[],
    attachments: Attachment[],
    filesToUpload: DocumentUploadFile[],
    type?: string,
    reportStart?: string,
    reportEnd?: string
  ) => {
    setIsSending(true);

    try {
      const workingCustomerId = _.clone(global.workingCustomerId);

      const result = (await sendFileToArchive(
        filesToUpload,
        workingCustomerId,
        "Inbox",
        setFailedWrapper
      )) as unknown;
      if (!result) {
        setIsSending(false);
        return;
      }
      const files = result as File[];
      let uploadedAttachments: File[] = [];
      if (files && files.length > 0) {
        uploadedAttachments = files.map((file) => {
          return { id: file.id, name: file.name, type: file.type };
        });
      }

      const allAttachments = [...attachments, ...uploadedAttachments];

      const sendMessageResult = (await sendMessage(
        user.userInfo?.id ?? "",
        body,
        title,
        null,
        recipients,
        workingCustomerId,
        allAttachments,
        type,
        reportStart,
        reportEnd
      )) as any;

      setIsSending(false);
      loadInbox();

      if (sendMessageResult) {
        fetchThread(global.workingCustomerId, sendMessageResult.threadId);
        navigate(
          `/inbox/thread/${encodeURIComponent(sendMessageResult.threadId)}`
        );
      }
    } catch (error) {
      setIsSending(false);
      console.error("Error sending message or uploading files:", error);
    }
  };

  return (
    <>
      {failed && (
        <FileUploadErrorModal failMessage={failMessage} setFailed={setFailed} />
      )}
      <h1>Ny konversation</h1>
      <hr className={"header-border"} />
      {isSending && !failed && (
        <MKLoader show={isSending} message="Skickar meddelande..." />
      )}
      <CreateThread
        isSending={isSending}
        showSubjectLine
        defaultRecipients={[]}
        onSend={handleOnSend}
      />
    </>
  );
}
